<template>
  <div>
    <div v-if="displayedErrorMessage" :class="{ error: true, 'fade-out': isFading }" role="alert" aria-live="assertive">
      <span>{{ displayedErrorMessage }}</span>
      <!-- <div v-if="errorMessage || store.errorMessage" :class="{ error: true, 'fade-out': fadeOut }"> -->
      <!-- <div v-if="errorMessage" class="error-message"> -->
      <!-- <span>{{ errorMessage }} || {{ store.errorMessage }}</span> -->
    </div>
  </div>

  <!-- <div v-if="store.errorMessage" class="error-message">
    {{ store.errorMessage }}
    <button @click="clearErrorMessage">Close</button>
  </div> -->

</template>

<script>
import { store } from '@/Store';

export default {
  name: "ErrorMessage",
  // props: ["errorMessage"],
  props: {
    errorMessage: {
      type: String,
      default: "", // Default to an empty string if no prop is passed
    },
  },
  data() {
    return {
      fadeOut: false, // Flag to control fade-out animation
      isFading: null,
    };
  },

  computed: {
    // Determine which error message to display (prop or store)
    displayedErrorMessage() {
      return this.errorMessage || store.errorMessage;
    },
  },
  watch: {
    // Watch for changes in the displayed error message
    displayedErrorMessage(newMessage) {
      if (newMessage) {
        // Reset fade state when a new error message is set
        this.isFading = false;

        // Automatically fade out the error message after 5 seconds
        setTimeout(() => {
          this.isFading = true;
        }, 5000); // Adjust the duration as needed
      }
    },
  },
  // mounted() {
  //   // Automatically fade out the error message after 3 seconds
  //   setTimeout(() => {
  //     this.fadeOut = true;
  //   }, 500);
  // };
};
</script>

<style scoped>
.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
}

.error {
  background-color: #640101;
  color: white;
  width: 30%;
  position: absolute;
  top: 20px;
  /* Adjust the top position as needed */
  right: 20px;
  /* Adjust the right position as needed */
  padding: 0.5rem;
  /* Adjust padding for minimal height while maintaining readability */
  border-radius: 5px;
  /* Optional: Add border radius for rounded corners */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Optional: Add shadow for better visibility */
  line-height: 1;
  /* Set line height to 1 to make it as small as possible */
  animation: fade-in 2s forwards;
  /* Apply fade animation */
}

.fade-out {
  animation: fade-out 2s forwards;
  /* Apply fade-out animation */
}

@keyframes fade-out {
  0% {
    opacity: 1;
  }

  /* Start with opacity 1 */
  100% {
    opacity: 0;
  }

  /* End with opacity 0 */
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  /* Start with opacity 0 */
  100% {
    opacity: 1;
  }

  /* End with opacity 1 */
}
</style>
